/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkSkillAssignmentRequestSchema = z.object({
  resourceIds: z
    .array(z.int())
    .min(1)
    .max(100)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
  skillIdsToAdd: z
    .array(z.int())
    .min(0)
    .max(100)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
  skillIdsToRemove: z
    .array(z.int())
    .min(0)
    .max(100)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
});
